import { AxiosResponse } from "axios";
import apiClient from "../../../../shared/infrastructure/api/client";
import { StripeConnectStatus } from "../../domain/types";

export const StripeConnectAPI = {
    status: (): Promise<AxiosResponse<StripeConnectStatus>> =>
        apiClient.get("/stripe/connect/status"),

    /**
     * Returns the Stripe consent URL for the caller to navigate to.
     *
     * The redirect is not followed here: this is an authenticated XHR, and
     * Stripe's consent screen has to be a top-level navigation for the
     * therapist to see and interact with it.
     */
    authorizeUrl: (): Promise<AxiosResponse<{ url: string }>> =>
        apiClient.get("/stripe/connect/authorize"),

    revoke: (): Promise<AxiosResponse<void>> => apiClient.delete("/stripe/connect"),
};
